import React, { FC, useState } from 'react';
import { Input } from 'antd';
import Modal from 'Components/Modal/Modal';
import { Button } from 'Components';
import styles from './ModalForm.module.scss';
import useLogin from '../Hooks/LoginHooks';
import { ReactComponent as EyeOpen } from '../../../../Icons/new-eye-oppened.svg';
import { ReactComponent as EyeCross } from '../../../../Icons/new-eye-crossed.svg';

interface Props {
	visible: boolean;
	onCancel: () => void;
	setShowResetPassword: React.Dispatch<React.SetStateAction<boolean>>;
}

const AdminLoginModal: FC<Props> = ({
	visible,
	onCancel,
	setShowResetPassword
}) => {
	const formik = useLogin();
	const [showPass, setShowPass] = useState(false);

	const viewPass = () => setShowPass(true);
	const hidePass = () => setShowPass(false);

	const forgotPassword = () => {
		onCancel();
		setShowResetPassword(true);
	};

	const ErrorComponent = (
		<div className={styles.errorMsg}>
			<strong>Invalid username or password.</strong> Try again, reset your
			password, or contact your manager.
		</div>
	);

	return (
		<Modal
			visible={visible}
			centered
			onCancel={onCancel}
			footer={null}
			size="xs"
		>
			<div className={styles.container}>
				<div className={styles.title}>Venza Admin Sign-In</div>

				<form onSubmit={formik.handleSubmit}>
					<div className={styles.field}>
						<label>Username</label>
						<Input
							name="username"
							placeholder="Enter your username"
							size="large"
							value={formik.values.username}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							onPressEnter={() => formik.submitForm()}
							disabled={formik.isSubmitting}
						/>
						{formik.touched.username && formik.errors.username && (
							<div className={styles.errorMsg}>
								{formik.errors.username}
							</div>
						)}
					</div>

					<div className={styles.field}>
						<label>Password</label>
						<Input
							name="password"
							type={showPass ? 'text' : 'password'}
							placeholder="Enter your password"
							size="large"
							suffix={
								showPass ? (
									<EyeCross onClick={hidePass} />
								) : (
									<EyeOpen onClick={viewPass} />
								)
							}
							value={formik.values.password}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							onPressEnter={() => formik.submitForm()}
							disabled={formik.isSubmitting}
						/>
						{formik.touched.password && formik.errors.password && (
							<div className={styles.errorMsg}>
								{formik.errors.password}
							</div>
						)}
					</div>

					{/* API error */}
					{formik.status && ErrorComponent}

					<Button
						type="primary"
						shape="round"
						className="cta-prominent"
						htmlType="submit"
						style={{ marginTop: formik.status ? '0' : '16px' }}
						loading={formik.isSubmitting}
						disabled={formik.isSubmitting}
					>
						Log in
					</Button>
				</form>

				<div className={styles.forgotPassword} onClick={forgotPassword}>
					Forgot your password?
				</div>

				<div className={styles.helperText}>
					This page is for Venza admins only. Client administrators
					must log in through their portal.
				</div>
			</div>
		</Modal>
	);
};

export default AdminLoginModal;
